/**
 * En-tête commun à tous les écrans : marque, choix de langue, et éventuellement déconnexion.
 *
 * Le lien de marque pointe vers l’accueil ; il est masqué sur l’écran de jeu pour ne pas
 * interrompre une partie par un clic accidentel (la sortie passe par la déconnexion ou la fin de
 * run, M2).
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { BoutonDeconnexion } from './BoutonDeconnexion';
import { ChoixLangue } from './ChoixLangue';

export interface ProprietesEntete {
  /** Affiche le bouton de déconnexion (écrans accessibles une fois connecté). */
  readonly avecDeconnexion?: boolean;
}

export function Entete({ avecDeconnexion = false }: ProprietesEntete) {
  const { t } = useTranslation();
  return (
    <header className="entete">
      <Link className="entete__marque" to="/">
        {t('app.nom')}
      </Link>
      <div className="entete__actions">
        <ChoixLangue compact />
        {avecDeconnexion ? <BoutonDeconnexion /> : null}
      </div>
    </header>
  );
}
